import { render, staticRenderFns } from "./GoodCat.vue?vue&type=template&id=655588e4&scoped=true&"
import script from "./GoodCat.vue?vue&type=script&lang=js&"
export * from "./GoodCat.vue?vue&type=script&lang=js&"
import style0 from "./GoodCat.vue?vue&type=style&index=0&id=655588e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655588e4",
  null
  
)

export default component.exports